import React, { createContext, useState } from 'react';

export const TabNameContext = createContext();

export function TabNameProvider({ children }) {
  const [selectedTabName, setSelectedTabName] = useState('Completed'); 

  return (
    <TabNameContext.Provider value={{ selectedTabName, setSelectedTabName }}>
      {children}
    </TabNameContext.Provider>
  );
}